var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 8.39414C8.57694 8.39414 9.44999 7.5211 9.44999 6.44414C9.44999 5.36719 8.57694 4.49414 7.49999 4.49414C6.42303 4.49414 5.54999 5.36719 5.54999 6.44414C5.54999 7.5211 6.42303 8.39414 7.49999 8.39414Z",
    stroke: "#4E008E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2625 5.30625C3.49375 -0.106249 11.5125 -0.0999984 12.7375 5.3125C13.4563 8.4875 11.4813 11.175 9.75 12.8375C8.49375 14.05 6.50625 14.05 5.24375 12.8375C3.51875 11.175 1.54375 8.48125 2.2625 5.30625Z",
    stroke: "#4E008E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPurple);
export default __webpack_public_path__ + "static/media/location-purple.c6e95a4ac3de11976b0e29a80876dd89.svg";
export { ForwardRef as ReactComponent };